import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-237" data-mp="3bhljv43cc8l2">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-238" data-mp="36iqshdrb5bpc">
        <span className="metal-silver inline-flex items-center gap-2 rounded-full border border-slate-400 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-blue-950" data-id="element-239" data-mp="31kp9stxsneee">
          <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="2wrw7ecpssi5h" /> The most comprehensive nuclear energy teaching system in
          the world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-241" data-mp="2nu3rp7g5z8hk">
          Nuclear Energy Teacher Ready
        </h2>
        <p className="mt-3 font-semibold text-slate-300" data-id="element-242" data-mp="2dveehrz7qc7n">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach nuclear energy with
          confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-243" data-mp="18q6hcj0o62xx">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-slate-300/20 bg-blue-950/60 p-4 text-sm font-semibold text-slate-300" data-id="element-244" data-mp="u2lfesfj69rl">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-245" data-mp="1cr04ha6afdpr" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-slate-300/40 bg-blue-950/70 p-6 text-left text-lg font-bold leading-relaxed text-white" data-id="element-246" data-mp="1buz1yerv12g">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-slate-300" aria-hidden="true" data-id="element-247" data-mp="28y4s8ce588z9" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          nuclear energy works, why safety matters, and how nuclear science contributes to solving global challenges.
        </p>
      </div>
    </section>;
}